import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { formaPagamentoProps, protocoloProps } from 'utils/types';
import { Container } from './styles';
import { ButtonBack } from 'components/ButtonBack';

const ButtonLink: React.FC = () => {
  const history = useHistory();

  const [verificarSituacao, setVerificarSituacao] = useState<any>();

  const resetarPagamento = useCallback(() => {
    window.stop();
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
    history.goBack();
  }, [history, verificarSituacao]);

  const protocoloPagamento = JSON.parse(
    sessionStorage.getItem('@CheckoutWeb:protocoloPagamento') ?? 'null',
  ) as protocoloProps | null;

  const formaPagamentoAtual = JSON.parse(
    sessionStorage.getItem('@CheckoutWeb:formaPagamento') ?? 'null',
  ) as formaPagamentoProps | null;

  if (
    !protocoloPagamento ||
    !formaPagamentoAtual ||
    protocoloPagamento.FormasPagamento.length !== 2
  ) {
    return <ButtonBack title={ "Outras formas de pagamento"} action={resetarPagamento} />;
  }

  const outraForma = protocoloPagamento.FormasPagamento.find(
    f => f.Id !== formaPagamentoAtual.Id,
  );

  if (!outraForma) return null;

  const handleClick = () => {
    sessionStorage.setItem('@CheckoutWeb:formaPagamento', JSON.stringify(outraForma));
    history.push('/pagamento');
  };

  return (
    <Container type="button" onClick={handleClick}>
      {'QUERO PAGAR COM ' + outraForma.Nome.toUpperCase()}
    </Container>
  );
};

export default ButtonLink;
